import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import uuid from 'uuid/v1';
import TagWithLink from './TagWithLink';
import itemTags from '../ItemsModules/itemTags';
import { move, copy, reorder } from '../../../../utils/dragAndDrop';


const TagsRow = ({
  activeLanguage, components, id, reusableComponent, reusableComponentSlugname, languages, handlerSetComponents,
}) => {
  // styles

  const initialState = {
    type: 'TagsRow',
    components: [],
    className: '',
  };

  const grid = 4;

  const getItemStyleContent = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    color: 'white',
    margin: `0 0 ${grid}px 0`,
    borderRadius: '4px',

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : '#292929',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getItemStyleType = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // padding: grid * 4,
    border: '1px solid #dae1e7',
    margin: '5.5% 4% 0 4%',
    borderRadius: '5px',

    // change background colour if dragging
    background: 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyleContent = isDraggingOver => ({
    background: 'black',
    padding: '10px 16px',
    position: 'absolute',
    top: 0,
    left: -1,
    width: '11.5%',
    height: '100%',
    marginLeft: '1.875rem',
  });

  const getListStyleType = (isDraggingOver, selectedLeft) => ({
    background: isDraggingOver ? 'transparent' : 'transparent',
    // padding: grid,
    zIndex: 100,
    paddingLeft: '2rem',
    paddingBottom: '2rem',
    border: '2px dashed #c8c8c8',
    borderRadius: '7px',
    paddingRight: '0rem',
    minHeight: '5rem',
  });

  const [selectedLeft, setSelectedLeft] = useState([]);
  const [items] = useState(itemTags);
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const handlerSetNestedComponentsLeft = (comp, i) => {
    const { component } = comp;

    selectedLeft[i].component = {
      ...component,
    };

    const newSelected = selectedLeft;
    newSelected[i].component = { ...component };
    const compTags = newSelected.map((comp) => {
      const newComp = { ...comp };
      if (!comp.component.compId) {
        newComp.component.compId = `${comp.component.type}_${uuid()}`;
      }
      return newComp.component;
    });
    console.log(compTags, 'comptags');

    // newSelected.forEach((tag) => {
    //   compTags.push(tag.component);
    // });

    const newState = {
      ...state,
      components: compTags,
    };
    setSelectedLeft(newSelected);
    setState(newState);

    const componentObj = {
      id,
      component: newState,
    };

    console.log(componentObj);

    handlerSetComponents(componentObj, index);
  };

  // useEffect(() => {
  //   const componentIndex = components.findIndex(obj => obj.id === id);
  //   const { component } = components[componentIndex];
  //   if (reusableComponent) {
  //     setState(reusableComponent);
  //     // if (!component) handlerSetSlider({ component: { key: reusableComponentSlugname } }, componentIndex);
  //   } else {
  //     setIndex(componentIndex);

  //     if (component) {
  //       setState(component);
  //     } else {
  //       const componentObj = {
  //         id,
  //         component: state,
  //       };
  //       // handlerSetSlider(componentObj, componentIndex);
  //     }
  //   }

  //   if (components[componentIndex]) {
  //     const sliderComponent = components[componentIndex].component;

  //     if (sliderComponent) {
  //       setSelectedLeft(sliderComponent.left);
  //     }
  //   }
  // }, [components]);


  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
        setSelectedLeft(component.components);
      } else {
        const componentObj = {
          id,
          component: state,
        };
        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const handleBlockClose = (componentId, side) => {
    if (side === 'left') {
      const componentToBeRemovedIndex = selectedLeft.findIndex(obj => obj.id === componentId);
      const arr = [...selectedLeft];
      arr.splice(componentToBeRemovedIndex, 1);
      setSelectedLeft(arr);
    }
  };
  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    switch (source.droppableId) {
      case destination.droppableId: {
        let newOrder;
        if (destination.droppableId === 'selectedLeft') {
          newOrder = reorder(selectedLeft, source.index, destination.index);
          setSelectedLeft(newOrder);
          const compTags = [];
          newOrder.forEach((tag) => {
            compTags.push(tag);
          });

          const newState = {
            ...state,
            components: compTags,
          };
          setState(newState);
          const componentObj = {
            id,
            component: newState,
          };

          handlerSetComponents(componentObj, index);
        }
        break;
      }
      case 'items': {
        if (destination.droppableId === 'selectedLeft') {
          const makeCopy = copy(items, selectedLeft, source, destination);
          setSelectedLeft(makeCopy);
          break;
        }
      }
      default: {
        let movedElements;
        if (source.droppableId === 'selectedLeft') {
          movedElements = move(selectedLeft, selectedRight, source, destination);
        }
        setSelectedLeft(movedElements.selectedLeft);
      }
    }
  };

  return (
    <>
      <div className="z-0 ml-11% min-h-143px max-h-550px">
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="w-full">

            <div className="w-1/4">
              <Droppable droppableId="items" isDropDisabled>
                {(provided, snapshot) => (
                  <div id="menu" ref={provided.innerRef} style={getListStyleContent(snapshot.isDraggingOver)}>
                    {items.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id} index={index}>
                        {(provided, snapshot) => (
                          <div id="module-button" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyleContent(snapshot.isDragging, provided.draggableProps.style)}>
                            {item.readableName}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>

            <div className="pl-2 w-full h-full">
              <Droppable droppableId="selectedLeft">
                {(provided, snapshot) => (
                  <div id="slider-container" ref={provided.innerRef} style={getListStyleType(snapshot.isDraggingOver, selectedLeft)} className="w-full">
                    {selectedLeft.length > 0
                      && selectedLeft.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index} activeLanguage={activeLanguage}>
                          {(provided, snapshot) => (
                            <div id={`left-content${index}`} ref={provided.innerRef} {...provided.draggableProps} style={getItemStyleType(snapshot.isDragging, provided.draggableProps.style)} className="relative">
                              <div className="bg-greyFilterItems text-grey-avatar absolute h-full px-1 z-10 pin-r pin-t flex items-center justify-center " {...provided.dragHandleProps}>
                                =
                              </div>
                              <button className="absolute pin-l pin-t" style={{ marginTop: '-20px', marginLeft: '2px' }} type="button">
                                <span className="px-4 font-americaMonoBold text-xxs text-white bg-black rounded">{item.readableName}</span>
                              </button>
                              <button
                                className="absolute pin-r pin-t h-4 w-4 flex items-center justify-center bg-black rounded-full"
                                style={{ marginTop: '-20px', marginRight: '2px' }}
                                type="button"
                                onClick={() => {
                                  handleBlockClose(item.id, 'left');
                                }}
                              >
                                <span className="font-icon icon-close-btn1 text-base text-white" />
                              </button>
                              {item.content === 'TagWithLink' && <TagWithLink id={item.id} languages={languages} components={selectedLeft} activeLanguage={activeLanguage} handlerSetComponents={handlerSetNestedComponentsLeft} slider />}
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>

          </div>
        </DragDropContext>
      </div>
    </>
  );
};

export default TagsRow;
